import React from 'react'
import { useNavigate } from 'react-router-dom'
import { LinkOutlined } from '@ant-design/icons'
import { useFilters, FilterKeyEnum } from 'src/shared/hooks'
import { PanelCategory } from '../hooks/useListFilters'
import { BrandsByCategory } from '../hooks/useListFilters'
import Format from 'src/shared/helpers/format'
import { dividerArr } from 'src/shared/utils/arrays'

import {
  Container,
  Column,
  Title,
  List,
  Section,
  ClickableItem,
  SubList,
  SubItem,
  ScrollableArea,
  BrandColumns,
  LinkWrapper,
  Wrapper,
  StickyButton,
} from './styles'

interface ProductsPanelContentProps {
  categories: PanelCategory[]
  handleClose?: () => void
  brandsByCategory: BrandsByCategory
}

export const ProductsPanelContent: React.FC<ProductsPanelContentProps> = ({
  categories,
  brandsByCategory,
  handleClose,
}) => {
  const navigate = useNavigate()
  const { applyNavigateFilter } = useFilters()

  const categoriesDivided = dividerArr(categories, 1)
  const brandsByCategoryDivided = dividerArr(brandsByCategory, 3)

  return (
    <Wrapper>
      <Container>
        <Column style={{ background: 'white' }}>
          <Title>Categorías</Title>
          <ScrollableArea>
            {categoriesDivided.map((group, idx) => (
              <List key={idx}>
                {group.map((catItem, index) => (
                  <Section key={`${catItem.id}-${index}`}>
                    <ClickableItem
                      onClick={() => {
                        handleClose?.()
                        applyNavigateFilter('/products', [
                          [FilterKeyEnum.categories, Format.capitalizeFirstLetter(catItem.name)],
                        ])
                      }}
                      style={{ fontWeight: 'bold' }}
                    >
                      {catItem.name}
                    </ClickableItem>
                    {catItem.subcategories && (
                      <SubList>
                        {catItem.subcategories.map((sub: any, i: any) => (
                          <SubItem
                            key={i}
                            onClick={() => {
                              handleClose?.()
                              applyNavigateFilter('/products', [
                                [FilterKeyEnum.categories, Format.capitalizeFirstLetter(sub.name)],
                              ])
                            }}
                          >
                            {sub.name}
                          </SubItem>
                        ))}
                      </SubList>
                    )}
                  </Section>
                ))}
              </List>
            ))}
          </ScrollableArea>
        </Column>

        <Column>
          <a className="link-page" onClick={() => navigate('/providers')}>
            Ver más marcas
          </a>
          <Title>Marcas </Title>
          <ScrollableArea>
            <BrandColumns>
              {brandsByCategoryDivided.map((group, index) => (
                <List key={index}>
                  {group.map((brandItem, idx) => (
                    <Section key={`${brandItem.category}-${idx}`}>
                      <LinkWrapper
                        href={`/products?categories=${brandItem.category}`}
                        onClick={() => handleClose?.()}
                        style={{ fontWeight: 'bold' }}
                      >
                        {brandItem.category}
                      </LinkWrapper>
                      <SubList>
                        {brandItem.brands.map((brand: any, i: any) => (
                          <LinkWrapper
                            key={i}
                            href={
                              brand.hasStore
                                ? `/providers/${brand.label}`
                                : `/products?brands=${brand.label}`
                            }
                            onClick={() => handleClose?.()}
                          >
                            {brand.label}
                          </LinkWrapper>
                        ))}
                      </SubList>
                    </Section>
                  ))}
                </List>
              ))}
            </BrandColumns>
          </ScrollableArea>
        </Column>
      </Container>
      <StickyButton href="/products">Ver todos los productos</StickyButton>
    </Wrapper>
  )
}
